import { findConnectionAppBySlug } from '@/data/connectionAppsCatalog'
import { titleFromSlug } from './titleFromSlug.js'

/** @param {{ id: string, toolkitSlug?: string, email?: string }} row */
export function resolveConnectionRow(row) {
  const slug = String(row.toolkitSlug || '')
    .trim()
    .toLowerCase()
  const catalog = slug ? findConnectionAppBySlug(slug) : undefined
  return {
    id: String(row.id),
    toolkitSlug: slug,
    title: catalog?.title || titleFromSlug(slug),
    iconUrl: catalog?.icon ?? null,
    email: String(row.email ?? '').trim(),
  }
}
